import { render, staticRenderFns } from "./radioTab.vue?vue&type=template&id=4ffdb39a&scoped=true"
import script from "./radioTab.vue?vue&type=script&lang=js"
export * from "./radioTab.vue?vue&type=script&lang=js"
import style0 from "./radioTab.vue?vue&type=style&index=0&id=4ffdb39a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffdb39a",
  null
  
)

export default component.exports